import { combineReducers } from "redux";

import { makeByIdReducer } from "../byIdReducer";
import { PAINTING_PREVIEWS } from "../../../constants/paintingConstants";
import { makeCollectionsReducer } from "../collectionsReducer";
import { paintingPreviewSchema } from "../../../schemas";
import filter from "./filter";


export default combineReducers({
  byId: makeByIdReducer(paintingPreviewSchema.key, [PAINTING_PREVIEWS.SUCCESS]),
  collections: makeCollectionsReducer(PAINTING_PREVIEWS.typeNames()),
  filter,
});